import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { authenticationVerificationSuccess } from '../app-start/app-start.actions';
import * as AuthenticationActions from '../authentication/state/authentication.actions';
import { NdtHubConnectionService } from './ndt-hub-connection.service';

@Injectable()
export class NdtHubConnectionEffects {
   createHubConnections = createEffect(
      () => {
         return this.actions.pipe(
            ofType(AuthenticationActions.loginSuccess, authenticationVerificationSuccess),
            tap(() => {
               this.hubService.startConnection();
            })
         );
      },
      { dispatch: false }
   );

   stopHubConnections = createEffect(
      () => {
         return this.actions.pipe(
            ofType(AuthenticationActions.reAuthenticationRequired),
            tap(() => {
               this.hubService.stopConnection();
            })
         );
      },
      { dispatch: false }
   );

   constructor(private hubService: NdtHubConnectionService, private actions: Actions) {}
}
